import React, { Component } from "react";
import ReporteConversionVentas from "./ReporteConversionVentas";

/**
 * Reporte "Cotizacion Vs Ventas".
 *
 * Por proyecto: cuanto se cotizo contra cuanto acabo siendo venta. Solo cuenta la venta
 * DIRECTA — una cotizacion que paso a Pedido y el pedido a Venta NO se considera convertida.
 *
 * Toda la pantalla vive en `ReporteConversionVentas`, que comparte con "Pedido Vs Ventas".
 */
const CONFIG = {
  titulo: "Cotizacion Vs Ventas",
  endpoint: "reporteCotizacionVsVentas",
  nombreFormulario: "reporteCotizacionVsVentas",
  nombreArchivo: "Cotizacion_Vs_Ventas",
  singular: "Cotizacion",
  plural: "Cotizaciones",
  etiquetaMonto: "Cotizado",
  etiquetaCantidad: "Cant. cotizada",
  rutaVer: "/panel/verCotizacion",
  campoEstado: "estadoCotizaciones",
  etiquetaFiltroEstado: "Estado de las Cotizaciones",
  // Mismos valores que consume `reporteCotizaciones` en el backend. El 7 ("Vencida") es un
  // estado derivado: no se guarda, se calcula contra `fechaVigencia`.
  opcionesEstado: [
    { value: 5, label: "Activas" },
    { value: 1, label: "Vigentes" },
    { value: 7, label: "Vencidas" },
    { value: 2, label: "Pendientes" },
    { value: 3, label: "Venta" },
    { value: 4, label: "Pedido" },
    { value: 0, label: "Canceladas" },
  ],
};

class ReporteCotizacionVsVentas extends Component {
  render() {
    return <ReporteConversionVentas {...this.props} config={CONFIG} />;
  }
}

export default ReporteCotizacionVsVentas;
